import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import DirectoryModal from "@/appComponents/Blocks/Modals/TableResultsModal/DirectoryModal";
import Header from "../Navigation/Header/Header";
import MainToolbarDirectory from "../Navigation/MainToolbar/MainToolbarDirectory";
import { isNullish } from "@theorgchartdev/storybook";
import { useWSMgrContext } from "@/providers/WsMgrProvider";
import { MainContainer } from "../Blocks/Utils/MainContainer";
import DirectoryTabularProvider from "@/providers/DirectoryTabularProvider";
import DirectoryTabularPage from "./directory/DirectoryTabular";

const DirectoryPage = () => {
  const ctx = useWSMgrContext();
  const wsMgr = ctx.wsMgr.state;
  const doc = wsMgr?.GetDoc();
  const isPositionDoc = doc?.IsPositionDocument();

  if (isPositionDoc) {
    return (
      <CentralizedModalContainer show={true}>
        <MainContainer>
          <DirectoryTabularProvider>
            <DirectoryTabularPage />
          </DirectoryTabularProvider>
        </MainContainer>
      </CentralizedModalContainer>
    );
  }
  return (
    <>
      <div className="appHeader">
        <Header />
        <div className="mainToolBar">
          <MainToolbarDirectory />
        </div>
      </div>
      <CentralizedModalContainer show={true}>
        <MainContainer>{!isNullish(doc) ? <DirectoryModal doc={doc} /> : null}</MainContainer>
      </CentralizedModalContainer>
    </>
  );
};

export default DirectoryPage;
